import { z } from 'zod'

/**
 * 모든 에러 응답의 공통 형태.
 *
 * 프론트가 code로 분기하고 message를 사용자에게 보여준다.
 * message는 사용자에게 노출되므로 내부 사정(스택, SQL)을 담지 않는다.
 */
export const errorResponse = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** 필드 단위 검증 실패. 폼에서 어느 칸이 틀렸는지 표시할 때 쓴다. */
    fields: z.record(z.string(), z.string()).optional(),
  }),
})
export type ErrorResponse = z.infer<typeof errorResponse>

/**
 * 비밀번호 정책 (설계 명세서 1.1).
 * 10자 이상, 영문·숫자·기호 중 2종 이상.
 */
export const password = z
  .string()
  .min(10, '비밀번호는 10자 이상이어야 합니다')
  .max(128)
  .refine((v) => {
    const kinds = [/[a-zA-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((re) => re.test(v)).length
    return kinds >= 2
  }, '영문·숫자·기호 중 2종 이상을 포함해야 합니다')

export const email = z.string().email('이메일 형식이 올바르지 않습니다').max(254)

export const role = z.enum(['COMPANY_ADMIN', 'COMPANY_MEMBER', 'OPERATOR', 'VENDOR_MEMBER'])
export type Role = z.infer<typeof role>
